import type { AppDispatch } from '@/store';
import { setUkek } from '@/store/slices/auth/authSlice';
import { setUkekInStorage } from '@/utils/sessionStorage';

/**
 * Single write path for the UKEK: Redux for the live session, sessionStorage for
 * the `/app` bootstrap restore-on-refresh (`appRoutes.ts`). The two copies must
 * never diverge — a stale stored UKEK cannot decrypt the current decaps key.
 *
 * Storage is skipped when the user id is unknown (login derives the UKEK before
 * the 2FA token yields an id); the bootstrap then has nothing to restore and the
 * login flow must complete to persist it.
 *
 * Unset is centralized in `logoutThunk` (`clearUkekFromStorage` + full store
 * reset) — do not add ad-hoc clear sites.
 */
export function persistUkek(dispatch: AppDispatch, userId: string | null, ukekHex: string): void {
  dispatch(setUkek(ukekHex));
  if (userId !== null && userId.trim() !== '') {
    setUkekInStorage(userId, ukekHex);
  }
}
